/**
 * created by li si yi
 */
import React, {Component} from 'react';
import SysStaticMyDesk from '../StaticMyDesk'
import NewContribution from "../components/newContribution/NewContribution";
import OrderDay from "../components/orderDay/OrderDay";
import PMSStoryStatisticsSMG from "../components/pmsStoryStatisticsSMG/PMSStoryStatisticsSMG";
import WorkDesktopUntreated from "../components/workDesktopUntreated/WorkDesktopUntreated";

export const newDesktopRouter = [
    {
        path: "/view/newDesktop/staticMyDesk",
        component: SysStaticMyDesk
    },
    {
        path: "/",
        component: SysStaticMyDesk
    },
    {
        path: "/view/newDesktop/components/newContribution",
        component: NewContribution
    },
    {
        path: "/view/newDesktop/components/orderDay",
        component: OrderDay
    },
    {
        path: "/view/newDesktop/components/pmsStoryStatisticsSMG",
        component: PMSStoryStatisticsSMG
    },
    {
        path: "/view/newDesktop/components/workDesktopUntreated",
        component: WorkDesktopUntreated
    },
];


